module.exports = __webpack_public_path__ + "img/user.66895589.svg";